import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import {
  gridSizeConst12,
  gridSizeMdLg12,
  gridSizeMdLg6,
  handleErrorForm,
  ModulosEnumChoice,
  solicitudTecnicoFormSchema,
  texto,
} from "@/shared";
import { useFetchPutPreagendamientoPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import {
  CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  LoaderComponent,
  SingleTableBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { Flota, Plan } from "@/shared/interfaces";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import { InfoPuntoEnlace } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import { useFlotasStore } from "@/store/erp";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useModalRechazoSolicitudTecnico } from "../../hook/useModalRechazoSolicitudTecnico";

interface IFormSolicitudTecnico {
  flota_adicional: string;
  coordenadas?: string;
}

interface SaveSolicitudTecnicoPymesProps {
  title: string;
  preagendamiento: IPreagendamientoPymes;
  router_path: string;
  es_corporativo: boolean;
}

export default function SaveSolicitudTecnicoPymes({
  title,
  preagendamiento,
  router_path,
  es_corporativo,
}: SaveSolicitudTecnicoPymesProps) {
  const [dataEnlace, setDataEnlace] = useState<InfoPuntoEnlace | undefined>(
    undefined,
  );
  const [dataPlan, setDataPlan] = useState<Plan | undefined>(undefined);

  const { plans } = usePlanStore();

  const form = useForm<IFormSolicitudTecnico>({
    resolver: yupResolver(solicitudTecnicoFormSchema),
  });

  const navigate = useNavigate();

  ///* store
  const { isLoadingFlotas, getFlotas } = useFlotasStore();

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const useHookModalMotivoRechazo = useModalRechazoSolicitudTecnico({
    modulo: ModulosEnumChoice.PREAGENDAMIENTO_PYMES,
    returnUrl: router_path,
  });

  ///* react query

  const { mutateAsync } = useFetchPutPreagendamientoPymes({
    navigate,
    returnUrl: router_path,
  });

  useEffect(() => {
    getFlotas({
      //es_corporativo: true
    });
    return () => {};
  }, []);

  useEffect(() => {
    const puntoEnlace = preagendamiento.preventa_pymes_data.coordenadas.find(
      (e) => e.nombre == preagendamiento.nombre_enlace,
    );
    if (!puntoEnlace) return;
    setDataEnlace(puntoEnlace);
    const plan = plans.find((e) => e.codigo == puntoEnlace.plan);
    setDataPlan(plan);
    form.setValue("coordenadas", puntoEnlace.coordenada);
    return () => {};
  }, []);

  const { fetchAutocompleteFlota } = useAutocompleteFetch();

  if (isLoadingFlotas) {
    return <LoaderComponent />;
  }

  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableBackBtn={true}
        backPageUrl={router_path}
        py={3}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Aprobar"
        iconCreateOrEdit={<CheckCircleIcon />}
        fnCreateOrEdit={form.handleSubmit(
          () => {
            setConfirmDialogIsOpen(true);

            setConfirmDialog({
              isOpen: true,
              title: "Confirmar",
              subtitle:
                "La solicitud de técnico esta por ser aprobada. ¿Estás seguro? Este cambio es irreversible.",
              confirmTextBtn: "Si",
              onConfirm: form.handleSubmit(async () => {
                try {
                  if (!preagendamiento.id_preagendamiento_pymes) return;
                  await mutateAsync({
                    id: preagendamiento.id_preagendamiento_pymes,
                    data: {
                      //estado_preagendamiento: EstadosPreagendamientoEnumChoice.EN_ESPERA,
                      solicitar_tecnico: false,
                      flota_adicional: form.getValues().flota_adicional,
                    },
                  });
                } catch (error) {
                } finally {
                  setConfirmDialogIsOpen(false);
                }
              }),
              onClose: () => {
                setConfirmDialogIsOpen(false);
              },
            });
          },
          (error) => {
            handleErrorForm(error);
          },
        )}
        enableAccionBtn={true}
        fnAccionBtn={() => {
          ///* rechazar
          useHookModalMotivoRechazo.setDialogContentText(
            `Estás a punto de rechazar una solicitud de técnico. ¿Estás seguro? Este cambio es irreversible.`,
          );
          useHookModalMotivoRechazo.setModalCancelar(true);
          useHookModalMotivoRechazo.reset({
            id: preagendamiento.id_preagendamiento_pymes,
            observaciones: preagendamiento.observaciones,
          });
        }}
      >
        <Box
          sx={{
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            //border: '1px solid #ccc'
          }}
        >
          <Grid container spacing={3} width={"80%"}>
            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Información Cliente"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Razon Social Empresa"}
              defaultValue={preagendamiento?.prospecto_pymes_data.razon_social}
              size={gridSizeMdLg12}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.direccion}
              defaultValue={dataEnlace?.direccion}
              size={gridSizeMdLg12}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel text={"Servicio"} pt={0} mt={0} pb={0} pl={0} />
            </Grid>

            <CustomTextFieldNoForm
              disabled={true}
              label={"Tipo Servicio"}
              defaultValue={dataPlan?.tipo_servicio}
              value={dataPlan?.tipo_servicio}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={"BW Inicial"}
              defaultValue={dataPlan?.velocidad_subida_maxima}
              size={gridSizeMdLg6}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Localidad Servicio"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            <CustomCoordendasForm
              size={gridSizeConst12}
              //key={field.id}
              label={`Coordenada`}
              defaultValue={form.getValues().coordenadas}
              name={"coordenadas"}
              form={form}
              onlyValueLocation={true}
              disabled={true}
              canLocationSearch={false}
              canDragMarker={false}
            />

            {/* <CustomTextFieldNoForm
              disabled={true}
              label={texto.coordenadas}
              defaultValue={dataEnlace?.coordenada}
              size={gridSizeMdLg12}
            /> */}

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.provincia}
              defaultValue={preagendamiento?.provincia_data?.nombre}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.city}
              defaultValue={preagendamiento?.ciudad_data?.nombre}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={texto.zona}
              defaultValue={preagendamiento?.zona_data?.nombre}
              size={gridSizeMdLg6}
            />

            {/* <CustomTextFieldNoForm
              disabled={true}
              label={texto.sector}
              defaultValue={preagendamiento?.sector_data?.nombre}
              size={gridSizeMdLg6}
            /> */}

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Información de Solicitud"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            {/* <CustomTextFieldNoForm
              disabled={true}
              label={'Fecha Técnico Adicional'}
              defaultValue={formatDate(preagendamiento?.fecha_tecnico_adicional!)}
              size={gridSizeMdLg6}
            />

            <CustomTextFieldNoForm
              disabled={true}
              label={'Hora Técnico Adicional'}
              defaultValue={preagendamiento?.hora_tecnico_adicional ?? 'N/A'}
              size={gridSizeMdLg6}
            /> */}

            <CustomTextAreaNoForm
              disabled={true}
              label={`Información`}
              value={
                preagendamiento?.observaciones?.observacion_tecnico_adicional ??
                "N/A"
              }
              defaultValue={
                preagendamiento?.observaciones?.observacion_tecnico_adicional ??
                "N/A"
              }
              size={gridSizeMdLg12}
            />

            <Grid item {...gridSizeMdLg12}>
              <TabTextLabel
                text={"Asignar Técnico"}
                pt={0}
                mt={0}
                pb={0}
                pl={0}
              />
            </Grid>

            {/* <CustomAutocomplete<Flota>
              disabled={false}
              size={gridSizeMdLg12}
              label={'Técnicos Disponibles'}
              name="flota_adicional"
              options={flotas || []}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().flota_adicional}
              isLoadingData={isLoadingFlotas}
              control={form.control}
              error={form.formState.errors.flota_adicional}
              helperText={form.formState.errors.flota_adicional?.message}
              onChangeValue={(e) => {
                form.setValue('flota_adicional', e)
              }}
            /> */}

            <CustomAutocompleteFetchForm<Flota>
              control={form.control}
              required={false}
              size={gridSizeMdLg12}
              name="flota_adicional"
              label="Técnico"
              fetchData={fetchAutocompleteFlota} ///* TODO: Pendiente revisar
              getOptionLabel={(opt) => `${opt.nombre}` || ""}
              fetchParams={{
                es_corporativo: es_corporativo,
              }}
              key={"autocomplete-producto"}
              getOptionKey={(opt) => opt.codigo}
              isAll={false}
              //getValue={(opt) => opt.codigo}
              //valueKey="codigo"
              onChangeValue={(e) => {
                form.setValue("flota_adicional", e as string);
              }}
            />
          </Grid>
        </Box>
      </SingleTableBoxScene>

      <ModalMotivoRechazo {...useHookModalMotivoRechazo} />
    </>
  );
}
